<template>
  <div class="flex min-h-screen flex-col">
    <router-view />
  </div>
  <ToastContainer />
</template>

<script setup lang="ts">
import ToastContainer from '@/components/feedback/ToastContainer.vue';
</script>
